import { createMuiTheme, responsiveFontSizes } from '@material-ui/core';

import components from './components';
import { light, dark } from './palette';

const getTheme = (mode, ext = {}) => {
  const customLight = { ...light, ...ext?.palette };
  const customDark = { ...dark, ...ext?.palette };

  return responsiveFontSizes(
    createMuiTheme({
      palette: mode === 'light' ? customLight : customDark,
      layout: {
        contentWidth: 1236,
      },
      components,
      typography: {
        fontFamily: 'Lato',
      },
      zIndex: {
        appBar: 1200,
        drawer: 1100,
      },
      shape: {},
    }),
  );
};

export default getTheme;
